// @flow

import { localStorage } from 'dibs-browser-storage';

const TRADE_SOURCING_REQUEST_SUBMITTED = 'TRADE_SOURCING_REQUEST_SUBMITTED';
const TRADE_SOURCING_PDP_MODAL_REQUEST_SUBMITTED = 'TRADE_SOURCING_PDP_MODAL_REQUEST_SUBMITTED';

export function setSourcingRequestSubmitted() {
    return localStorage.setItem(TRADE_SOURCING_REQUEST_SUBMITTED, true);
}

export function getSourcingRequestSubmitted() {
    return localStorage.getItem(TRADE_SOURCING_REQUEST_SUBMITTED) || false;
}

export function setPdpSourcingModalRequestSubmitted() {
    return localStorage.setItem(TRADE_SOURCING_PDP_MODAL_REQUEST_SUBMITTED, true);
}

export function getPdpSourcingModalRequestSubmitted() {
    return localStorage.getItem(TRADE_SOURCING_PDP_MODAL_REQUEST_SUBMITTED) || false;
}
